module.exports = __webpack_public_path__ + "img/29_14.12592510.png";